import React from 'react';
import { useTranslation } from 'react-i18next';

import { RadioItem } from '@/components/RadioItem';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { Box, TouchableBox } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { Product } from '@/hooks/use-jurisdiction';
import { common } from '@/styles/styles';

type Props = {
    product: Product.Pickem | Product.Sweeps | Product.Arcade;
    selected: boolean;
    onPress: () => void;
};

export const GameOption = ({ product, selected, onPress }: Props) => {
    const { t } = useTranslation('product_switch');

    return (
        <TouchableBox
            padding={'s20'}
            borderRadius={'r16'}
            borderWidth={2}
            gap={'s16'}
            borderColor={ds.colorToken.border.strong}
            flexDirection={'row'}
            style={[selected && { borderColor: ds.colorValue.border.subtle }, common.borderCurve]}
            onPress={onPress}
        >
            <Box flex={1}>
                <Text variant="titleLarge">{t(`${product}.title`)}</Text>
                <SizedBox value={4} />
                <Text color={ds.colorToken.text.secondary} variant="bodyMedium">
                    {t(`${product}.description`)}
                </Text>
            </Box>
            <RadioItem selected={selected} />
        </TouchableBox>
    );
};
